import {Companies} from "./models.js";

function StoryChoice() {

    // Integer
    const year = null;
    const monthCount = null;

    // String
    const choice = null;
    const information = null;

    // Foreign keys
    const companyId = null;

    return {
        year,
        monthCount,
        choice,
        information,
        companyId,
    };
}

function getStoryChoiceCompany(storyChoice) {
    return Companies.find({'$loki': storyChoice.companyId})[0];
}


export { StoryChoice, getStoryChoiceCompany }
